/**
 * Tasks Page
 * Standalone page for task management
 */

import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import TaskManagementTab from './TaskManagementTab';

const TasksPage: React.FC = () => {
  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      <Box mb={4}>
        <Typography variant="h4" fontWeight="bold" gutterBottom>
          Tasks
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Manage your tasks and follow-ups
        </Typography>
      </Box>
      <TaskManagementTab />
    </Container>
  );
};

export default TasksPage;
